import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import { NavLink, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import debounce from 'lodash.debounce';
import { setPrefillForm, setScrollbarWidth, setInputBoxVisibility } from 'store';

import api from 'api';
import WP from 'WP';
import { findScrollbarWidth } from 'helpers';

import Container from '../Container';
import GridElement from 'partials/GridElement';
import Chamburger from './Chamburger';
import MainMenu from './Menu';

import LogoLarge from 'icons/LogoLarge';
import LogoMedium from 'icons/LogoMedium';
import LogoSmall from 'icons/LogoSmall';
import Media, { ScreenWidth } from 'css/Media';
import LanguageSwitcher from 'partials/LanguageSwitcher';


class SiteHeader extends Component {

    constructor(props) {
        super(props);
        this.state = {
            menuVisible: false
        };
    }

    componentWillMount() {
        this.checkScreenSize();
        this.props.setScrollbarWidth(findScrollbarWidth())
    }

    componentDidMount() {   
        
        api.getMenuByLocation('primary_menu');
        api.getMenuByLocation('main_menu');
        window.addEventListener('keydown', this._onKeyDown.bind(this));
        window.addEventListener('resize', debounce(() => this.checkScreenSize()),500);
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', this._onKeyDown.bind(this));
        window.removeEventListener('resize', this.checkScreenSize());
    }

    _onKeyDown(e) {
        if(this.state.menuVisible) {
            e = e || window.event;
            let isEscape = false;
            if('key' in e) {
                isEscape = e.key === 'Escape' || e.key === 'Esc';
            } else {
                isEscape = e.keyCode === 27;
            }
            if(isEscape) {
                this.setState({ menuVisible: false });
            }
        }
    }

    _toggleMenu = () => {
        this.setState({ menuVisible: !this.state.menuVisible });
        this.props.setInputBoxVisibility(false);
    }

    maybeHandleSearchValue(item) {
        if(item.trigger_reset_search) {
            this.props.setPrefillForm(false);
        }
        this.props.history.push(item.url.replace(WP.base_url, ''));
    }

    checkScreenSize() {
        let size = 's';

        if(ScreenWidth.between('m', 'l')) {
            size = 'm';
        } else if(ScreenWidth.greaterThan('l')) {
            size = 'l';
        }

        this.setState({size: size});
    }

    handleMenuHeight(menu) {
        this.setState({menuHeight: menu});
    }

    render() {
        const { size, menuVisible, menuHeight } = this.state;
        const { primaryMenu, mainMenu, scrollbarWidth, overlayVisible, nightMode } = this.props;
        return (
            <React.Fragment>
                { !overlayVisible.visible &&
            <Header 
                id="header" 
                ref="header" 
                scrollbarWidth={scrollbarWidth}
                isMobile={size === 's'}
                isFrontPage={this.props.headerTopPadding}
                isDark={nightMode}
            >
                <Container grid>
                    <LogoGridElement
                        colStart={1}
                        colEnd={4}
                        colSpan
                        isDark={nightMode}
                    >
                        <NavLink to="/">
                            { size === 'l' ? 
                                <LogoLarge /> : 
                            size === 'm' ? 
                                <LogoMedium /> : 
                                <LogoSmall /> }
                        </NavLink>
                    </LogoGridElement>
                    { (size === 'm' || size === 'l' ) &&
                        <PrimaryMenuGridElement
                            colStart={{default: 7, xl: 9}} 
                            colEnd={{default: 20, xl: 20}} 
                            align="center"
                            fixed={menuVisible}
                            isDark={nightMode}
                        >
                            { primaryMenu && primaryMenu.map((item,idx) => {
                                return (
                                    <li key={idx} onClick={() => this.maybeHandleSearchValue(item)}>
                                        {item.title}
                                    </li>
                                )
                            })}
                        </PrimaryMenuGridElement>
                    }
                    { (!menuVisible || size === 's') &&
                        <GridElement
                            colStart={{default: 5, xs: 6, ss: 7, s: 20, m: 20, xl: 23}}
                            colEnd={{default: 8, xs: 8, ss: 8, s: 22, m: 23, xl: 24}}
                            justify={{default: "center", xs: "center", ss: "center", s: "end", xl: "start"}}
                            align="center"
                        >
                            <LanguageSwitcher fixed={menuVisible && size === 's'} isDark={nightMode} />
                        </GridElement>
                    }{ !overlayVisible.visible &&
                        <HamburgerWrapper 
                            onClick={this._toggleMenu}
                            scrollbarWidth={scrollbarWidth}
                            isMobile={size === 's'}
                            open={menuVisible}
                            isFrontPage={this.props.headerTopPadding}
                        >
                            <Chamburger open={menuVisible} isDark={nightMode} />
                        </HamburgerWrapper>
                    }
                </Container>
                { menuVisible &&
                   <MainMenu 
                        menu={mainMenu}
                        primaryMenu={primaryMenu}
                        menuHeight={menu => this.handleMenuHeight(menu)}
                        size={size}
                        toggle={this._toggleMenu} 
                    />
                }
                { (menuVisible && size !== 's') &&
                   <Backdrop onClick={() => this.setState({menuVisible: false})} menuHeight={menuHeight} />
                }
            </Header>
                }
            </React.Fragment>
        );
    }
}


const mapStateToProps = state => ({
    primaryMenu: state.menus[WP.lang].primary_menu ? state.menus[WP.lang].primary_menu.items : [],
    mainMenu: state.menus[WP.lang].main_menu ? state.menus[WP.lang].main_menu.items : [],
    scrollbarWidth: state.scrollbarWidth,
    overlayVisible: state.overlayValue,
    headerTopPadding: state.headerTopPadding,
    nightMode: state.nightMode,
    inputBoxVisibility: state.inputBoxVisibility,
});

const actions = {
    setPrefillForm,
    setScrollbarWidth,
    setInputBoxVisibility
}

export default connect(mapStateToProps, actions)(withRouter(SiteHeader));


const Header = styled.header`
    z-index: 999;
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;

    .container {
        padding-top: 30px;
        
        ${props => props.isMobile && css`
            padding-right: ${`calc(25px + ${props.scrollbarWidth}px)`};
        `}
        
        ${Media.greaterThan('m')`
            padding-top: ${props => props.isFrontPage ? '65' : '45'}px;
        `}

        ${Media.greaterThan('l')`
            padding-top: ${props => props.isFrontPage ? '75' : '55'}px;
        `}
    }
`

const LogoGridElement = styled(GridElement)`
    svg {
        fill: ${props => props.isDark ? props.theme.colors.negative : props.theme.colors.text};
    }
`

const PrimaryMenuGridElement = styled(GridElement)`
    display: flex;
    white-space: nowrap;

    li {
        list-style-type: none;
        ${props => props.theme.fonts.p}
        font-size: 20px;
        line-height: 42px;
        cursor: pointer;
        color: ${props => props.isDark ? props.theme.colors.negative : props.theme.colors.text};
        
    }

    ${Media.greaterThan('m')`
        padding-left: ${props => props.theme.spacing.contentXL};
        
        li {
            margin-right: ${props => props.theme.spacing.contentXL};
        }
    `}

    ${Media.greaterThan('l')`
        padding-left: ${props => props.theme.spacing.elementS};
        
        li {
            margin-right: ${props => props.theme.spacing.elementS};
        }
    `}
`

const HamburgerWrapper = styled.div`
    position: fixed;
    z-index: 4;
    top: ${props => props.theme.spacing.contentL};
    right: ${props => props.open ? '25px' : `calc(25px - ${props.scrollbarWidth}px)`};
    width: ${props => props.theme.spacing.elementXS};
    height: 34.67px;
    display: flex;
    justify-content: flex-end;
    align-items: center;

    ${Media.greaterThan('s')`
        right: 45px;
    `}

    ${Media.greaterThan('m')`
        top: ${props => props.isFrontPage ? '65' : '45'}px;
        right: 60px;
        height: 42px;
    `}

    ${Media.greaterThan('l')`
        top: ${props => props.isFrontPage ? '75' : '55'}px;
        right: 80px;
    `}

    ${Media.greaterThan('xl')`
        height: 49.56px;
        right: calc((100vw - 1800px) / 2);
    `}
`

const Backdrop = styled.div`
    position: absolute;
    height: 100vh;
    top: ${props => props.menuHeight}px;
    left: 0;
    right: 0;
    bottom: 0;
`
